function sparklineBar(id, values, height, barWidth, barColor, barSpacing) {
    $("." + id).sparkline(values, {
        type: "bar",
        height: height,
        barWidth: barWidth,
        barColor: barColor,
        barSpacing: barSpacing
    })
}
function sparklineLine(id, values, width, height, lineColor, fillColor, lineWidth, maxSpotColor, minSpotColor, spotColor, spotRadius, hSpotColor, hLineColor) {
    $("." + id).sparkline(values, {
        type: "line",
        width: width,
        height: height,
        lineColor: lineColor,
        fillColor: fillColor,
        lineWidth: lineWidth,
        maxSpotColor: maxSpotColor,
        minSpotColor: minSpotColor,
        spotColor: spotColor,
        spotRadius: spotRadius,
        highlightSpotColor: hSpotColor,
        highlightLineColor: hLineColor
    })
}
function sparklinePie(id, values, width, height, sliceColors) {
    $("." + id).sparkline(values, {
        type: "pie",
        width: width,
        height: height,
        sliceColors: sliceColors,
        offset: 0,
        borderWidth: 0
    })
}
function easyPieChart(id, trackColor, scaleColor, barColor, lineWidth, lineCap, size) {
    $("." + id).easyPieChart({
        trackColor: trackColor,
        scaleColor: scaleColor,
        barColor: barColor,
        lineWidth: lineWidth,
        lineCap: lineCap,
        size: size
    })
}

function sendFile(file,editor,welEditable,sn)
{
    sn.summernote('focus');
    $.getJSON("/media/upload/request",function(JSON){
        var form_data = new FormData();
        form_data.append('file', file);
        form_data.append('tkn',JSON.token);
        form_data.append('_token',$("input[name=_token]").val());
        $.ajax({
            data: form_data,
            type: "POST",
            url: '/media/upload/image',
            cache: false,
            contentType: false,
            processData: false,
            success: function(DATA) {
                var image = $('<img/>').attr('src', DATA);
                sn.summernote('insertNode',image[0]);
            }
        });
    });

}

function pasteHtmlAtCaret(html) {
    var sel, range;
    if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
            range = sel.getRangeAt(0);
            range.deleteContents();

            // Range.createContextualFragment() would be useful here but is
            // only relatively recently standardized and is not supported in
            // some browsers (IE9, for one)
            var el = document.createElement("div");
            el.innerHTML = html;
            var frag = document.createDocumentFragment(), node, lastNode;
            while ( (node = el.firstChild) ) {
                lastNode = frag.appendChild(node);
            }
            range.insertNode(frag);

            // Preserve the selection
            if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    } else if (document.selection && document.selection.type != "Control") {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
    }
}

function AppendTextAreaWISYWIG(element) {
    var sn=$(element);
    var height=parseInt($(element).css("height"));
    var cfg={
        disableDragAndDrop: true,
        toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'underline', 'clear']],
            ['color', ['color']],
            ['para', ['ul', 'ol']],
            ['insert',['picture','link']],
            ['view', ['fullscreen', 'codeview']]
        ],
        onChange: function() {
            $(this).closest("form").attr("data-dirty","true");
        },
        callbacks: {
            onImageUpload: function (files, editor, welEditable) {
                $.each(files, function (i, file) {
                    sendFile(file, editor, welEditable, sn);
                });
                return false;
            }
        },
        cleaner:{
            notTime: 0, // Time to display Notifications.
            action: 'both', // both|button|paste 'button' only cleans via toolbar button, 'paste' only clean when pasting content, both does both options.
            newline: '<br>', // Summernote's default is to use '<p><br></p>'
            notStyle: 'position:absolute;top:0;left:0;right:0', // Position of Notification
            icon: '<i class="note-icon">[Your Button]</i>',
            keepHtml: true, // Remove all Html formats
            keepOnlyTags: ['<p>', '<br>', '<ul>', '<li>', '<b>', '<strong>','<i>', '<a>'], // If keepHtml is true, remove all tags except these
            keepClasses: false, // Remove Classes
            badTags: ['style', 'script', 'applet', 'embed', 'noframes', 'noscript', 'html'], // Remove full tags with contents
            badAttributes: ['style', 'start'] // Remove attributes from remaining tags
        }
    };
    if($(element).attr("data-height")=="auto") {
        cfg.minHeight = height>150?height:150;
    }else {
        cfg.height= height>150?height:150;
    }
    if(languageCurrent=='de') {
        cfg.lang = 'de-DE';
    }else{
        cfg.lang = 'en-US';
    }
    element.sncopy=$(element).summernote(cfg);
}

function SetupTextArea() {

    $("textarea[data-no-summernote!='true']").each(function(){
        AppendTextAreaWISYWIG(this);
    });

    $("body").on("submit","form",function(){
        $("textarea[data-no-summernote!='true']").each(function(){
            if (this.sncopy && this.sncopy.summernote && this.sncopy.summernote('codeview.isActivated')) {
                this.sncopy.summernote('codeview.deactivate');
            }
        });
    });

    $("textarea.max-length-enabled, input.max-length-enabled").each(function() {
        var maxLen=$(this).attr("data-max-length");
        var template=$('<div class="pull-right" style="padding-top:5px;padding-bottom:10px;"><small>'+LANGUAGE['limiter.text'].replace('{0}',maxLen)+'</small></div>');
        var lenItem=template.find("small");
        $(this).parent().append(template);
        var $this=$(this);
        var Interval=0;
        var func=function(){
            lenItem.text(LANGUAGE['limiter.text'].replace('{0}',maxLen-$this.val().length));
        };
        $(this).on("keydown",function(e){
            if(e.keyCode!=8 && e.keyCode!=46 && $this.val().length>maxLen-1)
                return false;
            func();
        });
        $(this).on("keyup",func);
        func();
    });

}

$(function() {
    $.extend($.summernote.plugins,{
        'myenter':function(context){
            this.events = {
                // redefine insertParagraph
                'insertParagraph' : function(event, editor, layoutInfo) {

                    // custom enter key
                    var newLine = '<br />';
                    pasteHtmlAtCaret(newLine);

                    // to stop default event
                    event.preventDefault();
                }
            };
        }
    });

    $("<div class='flot-tooltip chart-tooltip'></div>").appendTo("body");

    $("#curved-line-chart")[0] && updateBigChart();

    SetupTextArea();
    
    $(".auto-chart").each(function(i,item){
        drawChart($(item));
    });

    $(".update-big-chart").on("click",updateBigChart);

    $("[data-only-show-if]").each(function() {
        var ifs=$(this).attr("data-only-show-if");
        var equ=$(this).attr("data-only-show-if-equal").split(",");
        var $self=$(this);

        var updateThisVisible=function(){
            if(equ.indexOf($(ifs).val())!=-1)
            {
                $self.slideDown(100);
            }else{
                $self.slideUp(100);
            }
        };
        $(ifs).on("change",updateThisVisible);
        updateThisVisible();
    });

    bigPieInstallsChart();

  /*  $(".flot-chart")[0] && ($(".flot-chart").bind("plothover", function(event, pos, item) {
        if (item) {
            var x = item.datapoint[0].toFixed(2)
                , y = item.datapoint[1].toFixed(2);
            $(".flot-tooltip").html(item.series.label + " of " + x + " = " + y).css({
                top: item.pageY + 5,
                left: item.pageX + 5
            }).show()
        } else
            $(".flot-tooltip").hide()
    }), */

});

function drawChart($item)
{
    var id=$item.attr("data-id");
    $.getJSON("/charts/"+id,function(data){
        $item.find(".count h2").text(data.raw);
        var values=[];
        $.each(data.set,function(i,item){
            values.push(item);
        });
        $item.find(".chart").sparkline(values, {
            type: "bar",
            height: "35px",
            width:"68px",
            barWidth: 5,
            barColor: "#fff",
            barSpacing: 2
        });
    });

}

function updateBigChart()
{
    var colors=["#8BC34A","#BA68C8","#FF9800","#607D8B","#00BCD4","#009688"];
    var options = {
        series: {
            shadowSize: 0,
            curvedLines: {
                apply: !0,
                active: !0,
                monotonicFit: !0
            },
            lines: {
                show: !1,
                lineWidth: 0
            }
        },
        grid: {
            borderWidth: 0,
            labelMargin: 10,
            hoverable: !0,
            clickable: !0,
            mouseActiveRadius: 6
        },
        xaxis: {
            tickDecimals: 0,
            ticks: !1
        },
        yaxis: {
            tickDecimals: 0,
            ticks: !1
        },
        legend: {
            show: !1
        },
        tooltip: !0,
        tooltipOpts: {
            content: "%p.0%, %s",
            shifts: {
                x: 20,
                y: 0
            },
            defaultTheme: !1,
            cssClass: "flot-tooltip"
        }
    };
    $.getJSON("/charts/all",function(json){
        var dataCharts=[];
        $.each(json,function(i,val){
            var vals=[];
            var o=1;
            $.each(val[1],function(k,item){
                vals.push([o++,item]);
            });
            dataCharts.push({
                data: vals,
                lines: {
                    show: !0,
                    fill: .98
                },
                label: val[0],
                stack: !0,
                color: colors[i]
            });
        });
        $.plot($("#curved-line-chart"), dataCharts, options);

    });
    return false;
}

function bigPieInstallsChart() {

    var colors = ["#8BC34A", "#BA68C8", "#FF9800", "#607D8B", "#00BCD4", "#009688"];


    var pieData = [{data: 0, color: "#8BC34A", label: "Android Smartphone"},{data: 0, color: "#8BC34A", label: "Android Tablet"}, {data: 0, color: "#00BCD4", label: "Apple iPhone"}, {data: 0, color: "#00BCD4", label: "Apple iPad"}];
    var options = {
        series: {
            pie: {
                show: !0,
                stroke: {
                    width: 2
                }
            }
        },
        legend: {
            container: ".flc-pie",
            backgroundOpacity: .5,
            noColumns: 0,
            backgroundColor: "white",
            lineWidth: 0
        },
        grid: {
            hoverable: 1,
            clickable: 1
        },
        tooltip: !0,
        tooltipOpts: {
            content: "%y.0 %s",
            shifts: {
                x: 20, y: 0
            },
            defaultTheme: !1,
            cssClass: "flot-tooltip"
        }
    };

    data1 = [[1, 60], [2, 30], [3, 50], [4, 100], [5, 10], [6, 90], [7, 85]], data2 = [[1, 20], [2, 90], [3, 60], [4, 40], [5, 100], [6, 25], [7, 65]], data3 = [[1, 100], [2, 20], [3, 60], [4, 90], [5, 80], [6, 10], [7, 5]];
    var barData = [{label: "Tokyo", data: data1, color: "#8BC34A"}, {
        label: "Seoul",
        data: data2,
        color: "#00BCD4"
    }, {label: "Beijing", data: data3, color: "#FF9800"}];

    var barOptions = {
        series: {bars: {show: !0, barWidth: .05, order: 1, fill: 1}},
        grid: {borderWidth: 1, borderColor: "#eee", show: !0, hoverable: !0, clickable: !0},
        yaxis: {
            tickColor: "#eee",
            min:0,
            font: {lineHeight: 13, style: "normal", color: "#9f9f9f"},
            shadowSize: 0,
            tickDecimals: 0,
            minTickSize: 50,
            tickSize: null
        },
        xaxis: {
            tickColor: "#fff",
            tickDecimals: 0,
            font: {lineHeight: 13, style: "normal", color: "#9f9f9f"},
            shadowSize: 0
        },
        legend: {container: ".flc-bar", backgroundOpacity: .5, noColumns: 4, backgroundColor: "white", lineWidth: 0},
        tooltip: !0,
        tooltipOpts: {
            content: "%y %s",
                shifts: {
                x: 20,
                    y: 0
            },
            defaultTheme: !1,
                cssClass: "flot-tooltip"
        }
    };



    $("#pie-chart").length && $.plot("#pie-chart", pieData, options);

    if ($("#lines-chart").length) {
        var res = [
            {data: [], color: "#8BC34A", label: "Android Phone"},
            {data: [], color: "#00BCD4", label: "Apple iOS Phone"},
            {data: [], color: "#BB8FCE", label: LANGUAGE['dashboard.charts.total.label']}
        ];

        var resRun = [
            {data: [], color: "#8BC34A", label: "Android"}, {data: [], color: "#00BCD4", label: "Apple iOS"}, {data: [], color: "#BB8FCE", label:  LANGUAGE['dashboard.charts.total.label']}
        ];

        var optionsLines = {
            series: {
                labels: "",
                lines: {
                    show: !0, lineWidth: 2, fill: 0
                },
                points: {show: true, fill: false},
                colors: ["#00BCD4", "#FFBCD4"],
                shadowSize: 0
            },
            yaxis: {
                min: 0,
                tickColor: "#eee",
                font: {
                    lineHeight: 13,
                    style: "normal",
                    color: "#9f9f9f"
                },
                shadowSize: 0,
                autoscaleMargin:1,
                tickDecimals: 0,
                minTickSize: 50,
                tickSize: null
            },
            xaxis: {
                tickColor: "#eee",
                show: !0,
                font: {
                    lineHeight: 13,
                    style: "normal",
                    color: "#9f9f9f"
                },
                ticks: [],
                shadowSize: 0
            }, grid: {
                borderWidth: 1,
                borderColor: "#eee",
                labelMargin: 10,
                hoverable: !0,
                clickable: !0,
                mouseActiveRadius: 6
            },
            legend: {
                container: ".flc-lines",
                backgroundOpacity: .5,
                noColumns: 0,
                backgroundColor: "white",
                lineWidth: 0
            },
            tooltip: !0,
            tooltipOpts: {
                content: "%y %s",
                shifts: {
                    x: 20,
                    y: 0
                },
                defaultTheme: !1,
                cssClass: "flot-tooltip"
            }
        };

        var optionsLinesRun = {
            series: {
                labels: "",
                lines: {
                    show: !0, lineWidth: 2, fill: 0
                },
                points: {show: true, fill: false},
                colors: ["#00BCD4", "#FFBCD4"],
                shadowSize: 0
            },
            yaxis: {
                min: 0,
                tickColor: "#eee",
                font: {
                    lineHeight: 13,
                    style: "normal",
                    color: "#9f9f9f"
                },
                shadowSize: 0,
                autoscaleMargin:1,
                tickDecimals: 0,
                minTickSize: 50,
                tickSize: null
            },
            xaxis: {
                tickColor: "#eee",
                show: !0,
                font: {
                    lineHeight: 13,
                    style: "normal",
                    color: "#9f9f9f"
                },
                ticks: [],
                shadowSize: 0
            }, grid: {
                borderWidth: 1,
                borderColor: "#eee",
                labelMargin: 10,
                hoverable: !0,
                clickable: !0,
                mouseActiveRadius: 6
            },
            legend: {
                container: ".flc-lines",
                backgroundOpacity: .5,
                noColumns: 0,
                backgroundColor: "white",
                lineWidth: 0
            },
            tooltip: !0,
            tooltipOpts: {
                content: "%y %s",
                shifts: {
                    x: 20,
                    y: 0
                },
                defaultTheme: !1,
                cssClass: "flot-tooltip"
            }
        };


        $.plot("#lines-chart", res, optionsLines);
        $.plot("#lines-chart-runs", resRun, optionsLinesRun);


        $.getJSON("/charts/allInstalls", function (data) {
            pieData[0].data = data.set.android;
            pieData[1].data = data.set.androidTablet;
            pieData[2].data = data.set.ios;
            pieData[3].data = data.set.iosTablet;
            if(data.set.android>0 || data.set.ios>0) {
                $("#show-no-results").hide();
            } else{
                $("#show-no-results").show();
            }
            $("#pie-chart").length && $.plot("#pie-chart", pieData, options);
        });

        $.getJSON("/charts/dateInstall",function(data){
            var i=0;
            $.each(data.set,function(key,item){
                optionsLines.xaxis.ticks.push([i,key]);
                res[0].data.push([i,item.android]);
                res[1].data.push([i,item.ios]);
                res[2].data.push([i++,item.both]);
            });
            $.plot("#lines-chart", res, optionsLines);
        });

        $.getJSON("/charts/dateRuns",function(data){
            var i=0;
            $.each(data.set,function(key,item){
                optionsLinesRun.xaxis.ticks.push([i,key]);
                resRun[0].data.push([i,item.android]);
                resRun[1].data.push([i,item.ios]);
                resRun[2].data.push([i++,item.both]);
            });
            $.plot("#lines-chart-runs", resRun, optionsLinesRun);
        });

        $.getJSON("/charts/viewspermodule",function(json) {
            var i=0;
            barData=[];
            var map={};
            $.each(json.fields,function(i,field){
                map[field]=i;
                barData.push({
                    data:[],
                    label:field,
                    color:colors[i]
                });
            });
            barOptions.xaxis.ticks=[];
            $.each(json.set,function(key,item){
                barOptions.xaxis.ticks.push([i,key]);
                $.each(item,function(key2,item2){
                    barData[map[key2]].data.push([i,item2]);
                });
                i++;
            });
            $("#bar-chart").length && $.plot($("#bar-chart"), barData, barOptions);
        });
    }
}
var data=[];
totalPoints=30;

function getRandomData(){
    for(data.length>0&&(data=data.slice(1));data.length<totalPoints;)
    {
        var prev=data.length>0?data[data.length-1]:50,
            y=prev+10*Math.random()-5;0>y?y=0:y>90&&(y=90),data.push(y)
    }

    res=[
        {data:[],color:"#8BC34A",label:"Android"},{data:[],color:"#00BCD4",label:"Apple iOS"}
    ];

    //
     for(var i=0;i<data.length;++i) {
         res[0].data.push([i,data[i]]);
         res[1].data.push([i,data[i]*2]);
     }
    return res
}

function appendOnRemove(data,remove) {

    remove();
  /*  console.log($($(this._originalElement).find("input[type=hidden]")[0]).val("deleted"));*/
    return true;
}